import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getAnalytics } from 'firebase/analytics'

// Firebase configuration for discovery-agent-app
const firebaseConfig = {
  apiKey: "AIzaSyBZLuLRJ1l-dMvCmn6iQaqkP9FSRR0U94Y",
  authDomain: "discovery-agent-app.firebaseapp.com",
  projectId: "discovery-agent-app",
  storageBucket: "discovery-agent-app.firebasestorage.app",
  messagingSenderId: "938335687555",
  appId: "1:938335687555:web:49653823877ad16ca89cb6",
  measurementId: "G-L6B8JC2F3N"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const db = getFirestore(app)
export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()

// Initialize Analytics (only in browser)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null

// Agent ID
export const AGENT_ID = 'nexus-leader'

export default app
